<template>
  <page>
    <!-- <div> -->
      <v-card>
        <v-tabs v-model="tabValue" slider-color="primary">
        <v-tab @click="resetTab">GL Interface List</v-tab>
        <v-tab v-show="review">GL Interface Details</v-tab>
        <v-tab v-show="query">GL Interface Details</v-tab>
        <v-tab-item>
          <v-flex xs12>
            <form>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.glApplnInt"
                                :label="labels.glApplnInt"
                                :error-messages="errors.collect('glApplnInt')"
                                data-vv-name="glApplnInt"
                                :data-vv-as="labels.glApplnInt"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.branch"
                                :label="labels.branch"
                                :error-messages="errors.collect('branch')"
                                data-vv-name="branch"
                                :data-vv-as="labels.branch"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.ctyRisk"
                                :label="labels.ctyRisk"
                                :error-messages="errors.collect('ctyRisk')"
                                data-vv-name="ctyRisk"
                                :data-vv-as="labels.ctyRisk"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.dri"
                                :label="labels.dri"
                                :error-messages="errors.collect('dri')"
                                data-vv-name="dri"
                                :data-vv-as="labels.dri"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.polType"
                                :label="labels.polType"
                                :error-messages="errors.collect('polType')"
                                data-vv-name="polType"
                                :data-vv-as="labels.polType"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.busCls"
                                :label="labels.busCls"
                                :error-messages="errors.collect('busCls')"
                                data-vv-name="busCls"
                                :data-vv-as="labels.busCls"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.dept"
                                :label="labels.dept"
                                :error-messages="errors.collect('dept')"
                                data-vv-name="dept"
                                :data-vv-as="labels.dept"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap v-if="showMore">
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.ctyCed"
                                :label="labels.ctyCed"
                                :error-messages="errors.collect('ctyCed')"
                                data-vv-name="ctyCed"
                                :data-vv-as="labels.ctyCed"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.ctyRi"
                                :label="labels.ctyRi"
                                :error-messages="errors.collect('ctyRi')"
                                data-vv-name="ctyRi"
                                :data-vv-as="labels.ctyRi"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.glAcctBrn"
                                :label="labels.glAcctBrn"
                                :error-messages="errors.collect('glAcctBrn')"
                                data-vv-name="glAcctBrn"
                                :data-vv-as="labels.glAcctBrn"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap v-if="showMore">
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.glAcctNo"
                                :label="labels.glAcctNo"
                                :error-messages="errors.collect('glAcctNo')"
                                data-vv-name="glAcctNo"
                                :data-vv-as="labels.glAcctNo"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.glAcctFund"
                                :label="labels.glAcctFund"
                                :error-messages="errors.collect('glAcctFund')"
                                data-vv-name="glAcctFund"
                                :data-vv-as="labels.glAcctFund"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.glAcctSfx"
                                :label="labels.glAcctSfx"
                                :error-messages="errors.collect('glAcctSfx')"
                                data-vv-name="glAcctSfx"
                                :data-vv-as="labels.glAcctSfx"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap v-if="showMore">
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.stmtLvl"
                                :label="labels.stmtLvl"
                                :error-messages="errors.collect('stmtLvl')"
                                data-vv-name="stmtLvl"
                                :data-vv-as="labels.stmtLvl"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.stmtLnGl"
                                :label="labels.stmtLnGl"
                                :error-messages="errors.collect('stmtLnGl')"
                                data-vv-name="stmtLnGl"
                                :data-vv-as="labels.stmtLnGl"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.glAcctSfx"
                                :label="labels.baGl"
                                :error-messages="errors.collect('baGl')"
                                data-vv-name="baGl"
                                :data-vv-as="labels.baGl"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.cedAreaGl"
                                :label="labels.cedAreaGl"
                                :error-messages="errors.collect('cedAreaGl')"
                                data-vv-name="cedAreaGl"
                                :data-vv-as="labels.cedAreaGl"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.riAreaGl"
                                :label="labels.riAreaGl"
                                :error-messages="errors.collect('riAreaGl')"
                                data-vv-name="riAreaGl"
                                :data-vv-as="labels.riAreaGl"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.cesCat"
                                :label="labels.cesCat"
                                :error-messages="errors.collect('cesCat')"
                                data-vv-name="cesCat"
                                :data-vv-as="labels.cesCat"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.riskAreaGl"
                                :label="labels.riskAreaGl"
                                :error-messages="errors.collect('riskAreaGl')"
                                data-vv-name="riskAreaGl"
                                :data-vv-as="labels.riskAreaGl"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn text @click.native="showMore = true" v-if="!showMore">Show More Filters</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </form>
          </v-flex>
          <!-- <v-spacer class="mt-2"></v-spacer> -->
          <!-- <v-flex xs12>
            <v-layout row>
              <v-spacer></v-spacer>
              <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                <template v-slot:activator="{ on }">
                  <v-btn color="secondary" class="white--text" v-on="on">
                    <span>Columns</span>
                    <v-icon right dark>mdi-table-column-plus-after</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-text>
                    <template v-if="columns.length > 0">
                      <v-checkbox
                        v-for="column in columns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-layout>
          </v-flex> -->
          <v-flex xs12>
            <v-card>
              <v-card-title>
                <div class="headline">GL Interfaces List</div>
              </v-card-title>
              <v-layout class="pr-3">
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class=" mr-2" @click="doNew">
                  New GL Interface
                  <v-icon right>mdi-plus</v-icon>
                </v-btn>
                <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                  <template v-slot:activator="{ on }">
                    <v-btn color="secondary" class="white--text" v-on="on">
                      <span>Columns</span>
                      <v-icon right dark>mdi-table-column-plus-after</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-text>
                      <template v-if="columns.length > 0">
                        <v-checkbox
                          v-for="column in columns"
                          :key="column.value"
                          :label="column.text"
                          :value="column.value"
                          v-model="selectedColumns"
                        ></v-checkbox>
                      </template>
                      <template v-else> No column found </template>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-layout>
              <v-data-table
                :headers="listHeaders"
                :items="items"
                v-bind:options.sync="pagination"
                :server-items-length="totalItems"
                :loading="loading"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                :no-data-text="noDataText"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td v-for="column in selectedColumns" :key="column">
                      {{ row.item[column] }}
                    </td>
                    <td class="table-action-header">
                      <table-action
                        :rowData="row"
                        query
                        @query="doQuery(row.item)"
                        review
                        @review="doReview(row.item)"
                        remove
                        @remove="doPromptRemove(row.item)"
                      ></table-action>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <confirm v-model="promptRemove" @ok="doDelete">
                <p>Are you sure you want to delete the selected GL Interface?</p>
              </confirm>
            </v-card>
          </v-flex>
        </v-tab-item>
        <v-tab-item v-show="review">
          <v-card v-if="review">
            <gl-interface2-review :id="glIntKey" :newGlInt="newGlInt" @close="resetTab"></gl-interface2-review>
          </v-card>
        </v-tab-item>
        <v-tab-item v-show="query">
          <v-card v-if="query">
            <gl-interface2-query :id="glIntKey" @close="resetTab"></gl-interface2-query>
          </v-card>
        </v-tab-item>
      </v-tabs>
      </v-card>
    <!-- </div> -->
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import GlInterface2Review from '@/components/parameters/GLInterface2/review/GLInterface2Review'
import GlInterface2Query from '@/components/parameters/GLInterface2/query/GLInterface2Query'

export default {
  data() {
    return {
      labels: {
        glApplnInt: 'GL Application Interface',
        branch: 'Branch',
        ctyRisk: 'Country Risk',
        dri: 'Direct / RI Inwards',
        polType: 'Policy Type',
        busCls: 'Business Class',
        dept: 'Department',
        ctyCed: 'Country Cedant',
        ctyRi: 'Country RI',
        // clmResCat: 'Claim Reserve Category',
        glAcctBrn: 'GL Account Branch',
        glAcctNo: 'GL Account No.',
        glAcctFund: 'GL Account Fund',
        glAcctSfx: 'GL Account Suffix',
        stmtLvl: 'Statement Level',
        stmtLnGL: 'Statement Line GL',
        busAnGL: 'Business Analysis GL',
        cedAreaGL: 'Cedant Area GL',
        riAreaGL: 'RI Area GL',
        cesCat: 'Risk Area GL',
        riskAreaGL: 'Cession Category'
      },
      columns: [
        { text: 'GL Application Interface', value: 'glApplnInt' },
        { text: 'Branch', value: 'branch' },
        { text: 'Country Risk', value: 'ctyRisk' },
        { text: 'Direct / RI Inwards', value: 'dri' },
        { text: 'Policy Type', value: 'polType' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Department', value: 'dept' },
        { text: 'Country Cedant', value: 'ctyCed' },
        { text: 'Country RI', value: 'ctyRi' },
        // { text: 'Claim Reserve Category', value: 'clmResCat' },
        { text: 'GL Account Branch', value: 'glAcctBrn' },
        { text: 'GL Account No.', value: 'glAcctNo' },
        { text: 'GL Account Fund', value: 'glAcctFund' },
        { text: 'GL Account Suffix', value: 'glAcctSfx' },
        { text: 'Statement Level', value: 'stmtLvl' },
        { text: 'Statement Line GL', value: 'stmtLnGl' },
        { text: 'Business Analysis GL', value: 'busAnGl' },
        { text: 'Cedant Area GL', value: 'cedAreaGl' },
        { text: 'RI Area GL', value: 'riAreaGl' },
        { text: 'Risk Area GL', value: 'riskAreaGl' },
        { text: 'Cession Category', value: 'cesCat' }
      ],
      filters: {
        glApplnInt: this.glApplnInt,
        branch: null,
        ctyRisk: null,
        dri: null,
        polType: null,
        busCls: null,
        dept: null,
        ctyCed: null,
        ctyRi: null,
        clmResCat: null,
        glAcctBrn: null,
        glAcctNo: null,
        glAcctFund: null,
        glAcctSfx: null,
        stmtLvl: null,
        stmtLnGl: null,
        baGl: null,
        cedAreaGl: null,
        riAreaGl: null,
        cesCat: null,
        riskAreaGl: null
      },
      selectedColumns: ['glApplnInt', 'glAcctBrn', 'glAcctNo', 'glAcctFund', 'glAcctSfx'],
      totalItems: 0,
      review: false,
      tabValue: 0,
      showMore: false,
      glIntKey: {
        glApplnInt: this.glApplnInt,
        branch: '',
        ctyRisk: '',
        dri: '',
        polType: '',
        busCls: '',
        dept: '',
        ctyCed: '',
        ctyRi: '',
        clmResCat: '',
        stmtLvl: '',
        stmtLnGl: '',
        baGl: '',
        cedAreaGl: '',
        riAreaGl: '',
        riskAreaGl: '',
        cesCat: ''
      },
      newGlInt: false,
      selectedGlInt: null,
      promptRemove: false,
      toogleArray: [false],
      query: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doColumn()
  },
  mounted() {
    this.fetchData(true)
  },
  methods: {
    doColumn() {
      let i = 1
      const columns = Object.entries(this.GLMappingKey)
      for (let [key, values] of columns) {
        switch (key) {
          case 'sepAcctCtyRisk': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'ctyRisk')
              i++
            }
            break
          }
          case 'sepAcctDri': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'dri')
              i++
            }
            break
          }
          case 'sepAcctBrn': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'branch')
              i++
            }
            break
          }
          case 'sepAcctPolType': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'polType')
              i++
            }
            break
          }
          case 'sepAcctBusCls': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'busCls')
              i++
            }
            break
          }
          case 'sepAcctDept': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'dept')
              i++
            }
            break
          }
          case 'sepAcctCtyCed': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'ctyCed')
              i++
            }
            break
          }
          case 'sepAcctCtyRi': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'ctyRi')
              i++
            }
            break
          }
          case 'sepAcctStmtLvl': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'stmtLvl')
              i++
            }
            break
          }
          case 'sepAcctStmtLnGL': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'stmtLnGL')
              i++
            }
            break
          }
          case 'sepAcctBAGL': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'busAnGL')
              i++
            }
            break
          }
          case 'sepAcctCedAreaGL': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'cedAreaGL')
              i++
            }
            break
          }
          case 'sepAcctRIAreaGL': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'riAreaGL')
              i++
            }
            break
          }
          case 'sepAcctCesCat': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'cesCat')
              i++
            }
            break
          }
          case 'sepAcctRiskAreaGL': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'riskAreaGL')
              i++
            }
            break
          }
          default: {
            break
          }
        }
      }
    },
    async fetchData(options) {
      const apiURI = this.menu.glInterfaceList2
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((glInt) => {
                const convertList = {
                  glApplnInt: glInt.glApplnInt,
                  branch: glInt.branch,
                  ctyRisk: glInt.ctyRisk,
                  dri: glInt.dri,
                  polType: glInt.polType,
                  busCls: glInt.busCls,
                  dept: glInt.dept,
                  ctyCed: glInt.ctyCed,
                  ctyRi: glInt.ctyRi,
                  clmResCat: glInt.clmResCat,
                  glAcctBrn: glInt.glAcctBrn,
                  glAcctNo: glInt.glAcctNo,
                  glAcctFund: glInt.glAcctFund,
                  glAcctSfx: glInt.glAcctSfx,
                  stmtLvl: glInt.stmtLvl,
                  stmtLnGl: glInt.stmtLnGl,
                  baGl: glInt.baGl,
                  cedAreaGl: glInt.cedAreaGl,
                  riAreaGl: glInt.riAreaGl,
                  riskAreaGl: glInt.riskAreaGl,
                  cesCat: glInt.cesCat
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedGlInt = data
      }
    },
    doDelete() {
      if (this.selectedGlInt) {
        const apiURI = this.menu.deleteGlInt2
        if (apiURI) {
          this.$http
            .post(apiURI, this.selectedGlInt)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.fetchData(false)
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      }
    },
    doNew() {
      this.review = true
      this.newGlInt = true
      this.tabValue = 1
    },
    doReview(glInt) {
      this.glIntKey.glApplnInt = glInt.glApplnInt
      this.glIntKey.branch = glInt.branch
      this.glIntKey.ctyRisk = glInt.ctyRisk
      this.glIntKey.dri = glInt.dri
      this.glIntKey.polType = glInt.polType
      this.glIntKey.busCls = glInt.busCls
      this.glIntKey.dept = glInt.dept
      this.glIntKey.ctyCed = glInt.ctyCed
      this.glIntKey.ctyRi = glInt.ctyRi
      this.glIntKey.clmResCat = glInt.clmResCat
      this.glIntKey.stmtLvl = glInt.stmtLvl
      this.glIntKey.stmtLnGl = glInt.stmtLnGl
      this.glIntKey.baGl = glInt.baGl
      this.glIntKey.cedAreaGl = glInt.cedAreaGl
      this.glIntKey.riAreaGl = glInt.riAreaGl
      this.glIntKey.riskAreaGl = glInt.riskAreaGl
      this.glIntKey.cesCat = glInt.cesCat
      this.review = true
      this.newGlInt = false
      this.tabValue = 1
    },
    doQuery(glInt) {
      this.glIntKey.glApplnInt = glInt.glapplnInt
      this.glIntKey.branch = glInt.branch
      this.glIntKey.ctyRisk = glInt.ctyRisk
      this.glIntKey.dri = glInt.dri
      this.glIntKey.polType = glInt.polType
      this.glIntKey.busCls = glInt.busCls
      this.glIntKey.dept = glInt.dept
      this.glIntKey.ctyCed = glInt.ctyCed
      this.glIntKey.ctyRi = glInt.ctyRi
      this.glIntKey.clmResCat = glInt.clmResCat
      this.query = true
      this.tabValue = 2
    },
    resetTab() {
      this.review = false
      this.query = false
      this.newGlInt = false
      this.tabValue = 0
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.filters.glapplnInt = null
      this.filters.branch = null
      this.filters.ctyRisk = null
      this.filters.dri = null
      this.filters.polType = null
      this.filters.busCls = null
      this.filters.dept = null
      this.filters.ctyCed = null
      this.filters.ctyRi = null
      this.filters.clmResCat = null
      this.filters.glacctBrn = null
      this.filters.glacctNo = null
      this.filters.glacctFund = null
      this.filters.glacctSfx = null
      this.filters.stmtLvl = null
      this.filters.stmtLnGL = null
      this.filters.busAnGL = null
      this.filters.cedAreaGL = null
      this.filters.riAreaGL = null
      this.filters.cesCat = null
      this.filters.riskAreaGL = null
      this.fetchData(false)
    }
  },
  computed: {
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find((a) => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    GLMappingKey() {
      return this.$store.state.glAcctParam.glMapping.glMappingKey
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData(false)
    },
    tabValue(value) {
      if (value === 0) this.fetchData(false)
    }
  },
  components: {
    GlInterface2Review,
    GlInterface2Query
  },
  mixins: [TableConst.default, MessageMixin],
  props: ['glapplnInt']
}
</script>

<style>
</style>
